import { defineWorkflow } from './workflow-builder'

/**
 * WF-TRF-01 (Inter-Warehouse Transfer) — `docs/tl-doc/12B-SERVICE-DATA/JAL_12B-SERVICE-DATA-WF-TRF-01.md` §1–§8 [C].
 * Penyimpangan (laporan 11): [R] `ACT_TRF_CANCEL_APPROVED` (Disetujui → Cancelled, Admin WH RM, alasan wajib) — BA TRF-01A
 * "Disetujui + cancellation requested → Setujui Pembatalan"; TL hanya mengenal pembatalan dari Requested oleh Sansugi.
 * Leftover (laporan 22): pembatalan juga dari Pending Approval (Supervisor / Kadiv) dan Preparing — prototype v7.44
 * trf-01a `berjalan` — lewat tiga aksi tambahan `ACT_TRF_CANCEL_APPROVED_SPV / _KADIV / _PREP`.
 */
export const WF_TRF = defineWorkflow({
  no: 6,
  code: 'WF-TRF-01',
  name: 'Inter-Warehouse Transfer Workflow',
  entity: 'transfer',
  statuses: [
    ['TRF_DRAFT', 'Draft', true, false, '#64748B', 'Draft transfer dibuat oleh Admin Sansugi'],
    ['TRF_REQUESTED', 'Requested', false, false, '#F59E0B', 'Permintaan terkirim ke Admin WH Utama'],
    ['TRF_PENDING_SPV', 'Pending Approval - Supervisor', false, false, '#3B82F6', 'Menunggu persetujuan Supervisor RM'],
    ['TRF_PENDING_KADIV', 'Pending Approval - Kadiv', false, false, '#3B82F6', 'Menunggu persetujuan Kadiv WH RM'],
    ['TRF_APPROVED', 'Disetujui', false, false, '#10B981', 'Disetujui penuh, siap picking'],
    ['TRF_PREPARING', 'Preparing', false, false, '#06B6D4', 'Operator RM memproses picking barang'],
    ['TRF_READY_SHIP', 'Siap Kirim', false, false, '#8B5CF6', 'Barang berada di area staging ZS-RM'],
    ['TRF_IN_TRANSIT', 'In Transit', false, false, '#EC4899', 'SJI diterbitkan, barang dalam perjalanan'],
    ['TRF_COMPLETED', 'Completed', false, true, '#059669', 'Barang diterima lengkap di Sansugi'],
    ['TRF_PARTIAL', 'Diterima Sebagian', false, false, '#F97316', 'Penerimaan parsial di Sansugi'],
    ['TRF_REJECTED', 'Ditolak', false, true, '#EF4444', 'Permintaan transfer ditolak'],
    ['TRF_CANCELLED', 'Cancelled', false, true, '#94A3B8', 'Permintaan transfer dibatalkan']
  ],
  actors: [
    ['ACT_TRF_ADMIN_SGI', 'Admin WH Sansugi', 'admin_wh_sansugi', { created_by: { _eq: '$CURRENT_USER.id' } }],
    ['ACT_TRF_ADMIN_RM', 'Admin WH RM', 'admin_wh_rm', null],
    ['ACT_TRF_OP_RM', 'Operator WH RM', 'operator_wh_rm', null],
    ['ACT_TRF_SPV_RM', 'WH RM Supervisor', 'wh_rm_supervisor', { created_by: { _neq: '$CURRENT_USER.id' } }],
    ['ACT_TRF_KADIV_RM', 'Kadiv WH RM', 'kadiv_wh_rm', null]
  ],
  components: [
    ['CMP_TRF_SUBMIT', 'Tombol Ajukan Permintaan', 'ACTION', { color: '#3B82F6', variant: 'primary' }],
    ['CMP_TRF_REVIEW_ADMIN', 'Tombol Review Admin RM', 'ACTION', {}],
    ['CMP_TRF_APP_SPV', 'Tombol Approve Supervisor', 'ACTION', {}],
    ['CMP_TRF_APP_KADIV', 'Tombol Approve Kadiv', 'ACTION', {}],
    ['CMP_TRF_REJECT', 'Tombol Reject Transfer', 'ACTION', {}],
    ['CMP_TRF_ASSIGN_PICK', 'Tombol Bagi Tugas Picking', 'ACTION', {}],
    ['CMP_TRF_STAGING_DONE', 'Tombol Selesai Staging', 'ACTION', {}],
    ['CMP_TRF_SHIP', 'Tombol Tandai Dikirim (SJI)', 'ACTION', {}],
    ['CMP_TRF_RECEIVE', 'Tombol Konfirmasi Penerimaan', 'ACTION', {}],
    ['CMP_TRF_CANCEL', 'Tombol Batalkan Permintaan', 'ACTION', {}],
    ['CMP_TRF_PANEL_HEADER', 'Panel Header Transfer', 'PANEL', {}],
    ['CMP_TRF_PANEL_ITEMS', 'Panel Detail Barang Transfer', 'PANEL', {}],
    ['CMP_TRF_PANEL_SHIPPING', 'Panel Pengiriman (SJI)', 'PANEL', {}],
    ['CMP_TRF_PANEL_RECEIVING', 'Panel Penerimaan di Sansugi', 'PANEL', {}]
  ],
  actions: [
    ['ACT_TRF_SEND', 'TRF_DRAFT', 'TRF_REQUESTED', 'CMP_TRF_SUBMIT', false, false, null],
    ['ACT_TRF_ADMIN_ACCEPT', 'TRF_REQUESTED', 'TRF_PENDING_SPV', 'CMP_TRF_REVIEW_ADMIN', false, false, null],
    ['ACT_TRF_ADMIN_REJ', 'TRF_REQUESTED', 'TRF_REJECTED', 'CMP_TRF_REJECT', true, true, null],
    ['ACT_TRF_APP_SPV', 'TRF_PENDING_SPV', 'TRF_PENDING_KADIV', 'CMP_TRF_APP_SPV', false, false, null],
    ['ACT_TRF_REJ_SPV', 'TRF_PENDING_SPV', 'TRF_REJECTED', 'CMP_TRF_REJECT', true, true, null],
    ['ACT_TRF_APP_KADIV', 'TRF_PENDING_KADIV', 'TRF_APPROVED', 'CMP_TRF_APP_KADIV', false, false, null],
    ['ACT_TRF_REJ_KADIV', 'TRF_PENDING_KADIV', 'TRF_REJECTED', 'CMP_TRF_REJECT', true, true, null],
    ['ACT_TRF_ASSIGN', 'TRF_APPROVED', 'TRF_PREPARING', 'CMP_TRF_ASSIGN_PICK', false, false, null],
    ['ACT_TRF_STAGING', 'TRF_PREPARING', 'TRF_READY_SHIP', 'CMP_TRF_STAGING_DONE', false, false, null],
    [
      'ACT_TRF_DISPATCH',
      'TRF_READY_SHIP',
      'TRF_IN_TRANSIT',
      'CMP_TRF_SHIP',
      false,
      false,
      { is_in_transit: true, dispatched_at: '$NOW' }
    ],
    [
      'ACT_TRF_RECEIVE_FULL',
      'TRF_IN_TRANSIT',
      'TRF_COMPLETED',
      'CMP_TRF_RECEIVE',
      false,
      false,
      { is_received: true, received_at: '$NOW' }
    ],
    ['ACT_TRF_RECEIVE_PART', 'TRF_IN_TRANSIT', 'TRF_PARTIAL', 'CMP_TRF_RECEIVE', true, false, null],
    [
      'ACT_TRF_RECEIVE_REMAINDER',
      'TRF_PARTIAL',
      'TRF_COMPLETED',
      'CMP_TRF_RECEIVE',
      false,
      false,
      { is_received: true, received_at: '$NOW' }
    ],
    ['ACT_TRF_CANCEL', 'TRF_REQUESTED', 'TRF_CANCELLED', 'CMP_TRF_CANCEL', true, true, null],
    ['ACT_TRF_CANCEL_APPROVED', 'TRF_APPROVED', 'TRF_CANCELLED', 'CMP_TRF_CANCEL', true, true, null],
    ['ACT_TRF_CANCEL_APPROVED_SPV', 'TRF_PENDING_SPV', 'TRF_CANCELLED', 'CMP_TRF_CANCEL', true, true, null],
    ['ACT_TRF_CANCEL_APPROVED_KADIV', 'TRF_PENDING_KADIV', 'TRF_CANCELLED', 'CMP_TRF_CANCEL', true, true, null],
    ['ACT_TRF_CANCEL_APPROVED_PREP', 'TRF_PREPARING', 'TRF_CANCELLED', 'CMP_TRF_CANCEL', true, true, null]
  ],
  eligibility: [
    ['ACT_TRF_SEND', 'ACT_TRF_ADMIN_SGI'],
    ['ACT_TRF_ADMIN_ACCEPT', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_ADMIN_REJ', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_APP_SPV', 'ACT_TRF_SPV_RM'],
    ['ACT_TRF_REJ_SPV', 'ACT_TRF_SPV_RM'],
    ['ACT_TRF_APP_KADIV', 'ACT_TRF_KADIV_RM'],
    ['ACT_TRF_REJ_KADIV', 'ACT_TRF_KADIV_RM'],
    ['ACT_TRF_ASSIGN', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_STAGING', 'ACT_TRF_OP_RM'],
    ['ACT_TRF_DISPATCH', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_RECEIVE_FULL', 'ACT_TRF_ADMIN_SGI'],
    ['ACT_TRF_RECEIVE_PART', 'ACT_TRF_ADMIN_SGI'],
    ['ACT_TRF_RECEIVE_REMAINDER', 'ACT_TRF_ADMIN_SGI'],
    ['ACT_TRF_CANCEL', 'ACT_TRF_ADMIN_SGI'],
    ['ACT_TRF_CANCEL_APPROVED', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_CANCEL_APPROVED_SPV', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_CANCEL_APPROVED_KADIV', 'ACT_TRF_ADMIN_RM'],
    ['ACT_TRF_CANCEL_APPROVED_PREP', 'ACT_TRF_ADMIN_RM']
  ],
  panels: [
    ['CMP_TRF_PANEL_HEADER', 'TRF_DRAFT', 'write', 'ACT_TRF_ADMIN_SGI'],
    ['CMP_TRF_PANEL_HEADER', 'TRF_REQUESTED', 'read', null],
    ['CMP_TRF_PANEL_HEADER', 'TRF_COMPLETED', 'read', null],
    ['CMP_TRF_PANEL_ITEMS', 'TRF_DRAFT', 'write', 'ACT_TRF_ADMIN_SGI'],
    ['CMP_TRF_PANEL_ITEMS', 'TRF_REQUESTED', 'read', null],
    ['CMP_TRF_PANEL_ITEMS', 'TRF_PREPARING', 'read', null],
    ['CMP_TRF_PANEL_SHIPPING', 'TRF_READY_SHIP', 'write', 'ACT_TRF_ADMIN_RM'],
    ['CMP_TRF_PANEL_SHIPPING', 'TRF_IN_TRANSIT', 'read', null],
    ['CMP_TRF_PANEL_RECEIVING', 'TRF_IN_TRANSIT', 'write', 'ACT_TRF_ADMIN_SGI'],
    ['CMP_TRF_PANEL_RECEIVING', 'TRF_COMPLETED', 'read', null]
  ],
  emailStatuses: [
    'TRF_REQUESTED',
    'TRF_PENDING_SPV',
    'TRF_PENDING_KADIV',
    'TRF_APPROVED',
    'TRF_IN_TRANSIT',
    'TRF_COMPLETED',
    'TRF_PARTIAL',
    'TRF_REJECTED'
  ]
})

export type TrfStatusCode = (typeof WF_TRF.spec.statuses)[number][0]
export type TrfActorCode = (typeof WF_TRF.spec.actors)[number][0]
export type TrfActionName = (typeof WF_TRF.spec.actions)[number][0]
export const buildWorkflowTrfSeed = WF_TRF.build
